import { UI_TOGGLE_LEFT_NAV, UI_TOGGLE_RIGHT_NAV } from "../actions";
import { stat } from "fs";

const state = {
  openLeftNavDrawer: true,
  openRightNavDrawer: true,
  loading: 1,
  errors: [],
  appReady: false,
  recentPeople: []
};

const mutations = {
  VIEW_PERSON(state, personData) {
    var personId;
    if (typeof personData === "number") {
      personId = personData;
    } else {
      personId = personData.id;
    }
    var exists = state.recentPeople.findIndex(person => person.id === personId);
    console.log("currently exists", exists);
    if (exists > -1) {
      console.log(state.recentPeople[exists]);
      state.recentPeople.splice(exists, 1);
    }
    state.recentPeople.unshift(personData);
    while (state.recentPeople.length > 50) {
      state.recentPeople.pop();
    }
  },
  [UI_TOGGLE_LEFT_NAV](state, payload) {
    state.openLeftNavDrawer = state.openLeftNavDrawer ? false : true;
    if (payload) {
      state.openLeftNavDrawer = payload;
    }
  },
  [UI_TOGGLE_RIGHT_NAV](state, payload) {
    state.openRightNavDrawer = state.openRightNavDrawer ? false : true;
    if (payload) {
      state.openRightNavDrawer = payload;
    }
  },
  AddAppLoading(state) {
    state.loading++;
  },
  RemoveAppLoading(state) {
    if (state.loading > 0) {
      state.loading--;
    }
    // if (state.loading <= 0) {
    //   state.appReady = true;
    // }
  },
  addError(state, error) {
    return state.errors.push(error);
  },
  APP_READY(state) {
    // if (state.loading <= 0) {
    state.appReady = true;
    // }
  }
};

const getters = {
  ui_showLeftNavDrawer(state) {
    return state.openLeftNavDrawer;
  },
  ui_showRightNavDrawer(state) {
    return state.openLeftNavDrawer;
  },
  isAppError(state) {
    return state.errors.length > 0;
  },
  isAppLoading(state) {
    return state.loading > 0;
  },
  isAppReady(state) {
    return state.appReady == true || state.loading <= 0;
  }
};

const actions = {
  LOAD_CONFIG: async ({ commit }) => {
    commit("RemoveAppLoading"); //removeAppLoading once
    // commit("APP_READY");
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
